"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelButton = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
const CertificationButton_1 = require("./certification/CertificationButton");
const CustomButton_1 = require("./custom/CustomButton");
const LabelHelpers_1 = require("./LabelHelpers");
const SensitivityButton_1 = require("./sensitivity/SensitivityButton");
const WarningButton_1 = require("./warning/WarningButton");
function LabelButtonInner(props) {
    switch (props.categoryType) {
        case 'certification':
            return react_1.default.createElement(CertificationButton_1.CertificationLabel, Object.assign({}, props));
        case 'warning':
            return react_1.default.createElement(WarningButton_1.WarningLabel, Object.assign({}, props));
        case 'sensitivity':
            return react_1.default.createElement(SensitivityButton_1.SensitivityLabel, Object.assign({}, props));
        case 'custom':
            return react_1.default.createElement(CustomButton_1.CustomLabel, Object.assign({}, props));
        default:
            (0, catalog_core_1.assertUnreachable)(props);
            return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
function LabelButton(props) {
    var _a;
    return (react_1.default.createElement(LabelHelpers_1.LabelButtonContext.Provider, { value: (_a = props.controls) !== null && _a !== void 0 ? _a : LabelHelpers_1.defaultLabelRenderControls },
        react_1.default.createElement(LabelButtonInner, Object.assign({}, props))));
}
exports.LabelButton = LabelButton;
//# sourceMappingURL=LabelButtons.js.map